import React from "react";
import _ from "lodash";
import classnames from "classnames";
import Confetti from "react-confetti";
import AppContainer from "../AppContainer";
import List from "../List";
import Loader from "../Loader";
import Image from "../image";
import ImgFromUrl from "react-image";
import AllergensDecorator from "../allergens-decorator";
import LockClosedIcon from "../icons/LockClosed.svg";
import LockOpenIcon from "../icons/LockOpen.svg";
import GiftIcon from "../icons/Gift.svg";
import CalendarIcon from "../icons/Calendar.svg";
import PlateIcon from "../icons/Plate.svg";
import moment from "../../utils/moment-timezone-with-data-2012-2022";
import styles from "./index.module.scss";
import { mediaTypes, getAppMedia } from "../../utils/media";
import { breakpoints } from "../../styles";

export default ({
  T,
  appStyles,
  isMenuItem,
  useCategoryImage,
  isGiftItem,
  isDeal,
  isNew,
  title,
  description,
  onClick,
  refEl,
  imagePreview,
  imageKey,
  itemToAnimate,
  image,
  isImageByUrl,
  isLocked,
  userUnlockedDeal,
  shouldAnimateCard,
  lockDescription,
  classNames,
  style,
  loading,
  imageObjectFit,
  allergens,
  prices,
  isFlexColumn = false,
  currencySymbol,
  expirationDate,
  isDealUsedInOrder,
  actionsRenderer,
  totalDealPrice,
  giftPrice,
}) => {
  const {
    orderItemsCardHeight,
    dealItemsCardHeight,
    imageItemFlexLayout,
    dealItemFlexLayout,
    ListCardTitle,
    displayDealBadge,
    DealBadge = {},
    GiftBadge = {},
    MenuItemPrice,
  } = appStyles;

  const itemFlexLayout =
    isDeal || isGiftItem ? dealItemFlexLayout || "column" : imageItemFlexLayout;

  const isFlexRow = itemFlexLayout === "row";
  const customObjectFit = _.get(imageObjectFit, "objectFit");

  const orderItemImageFitStyle = customObjectFit
    ? customObjectFit === "fit" || customObjectFit === "contain"
      ? { objectFit: "contain" }
      : { objectFit: "cover" }
    : appStyles.orderItemImageFit && { objectFit: appStyles.orderItemImageFit };

  const itemHeight =
    isDeal || isGiftItem ? dealItemsCardHeight || 400 : orderItemsCardHeight;
  const imageHeight =
    orderItemsCardHeight &&
    _.toNumber(_.replace(_.replace(itemHeight, "px", ""), "pt", "")) / 2;

  const translatedDescription = description ? T(description) : "";

  const withPoints = isGiftItem && _.isNumber(giftPrice);

  const defaultItemImage = getAppMedia(mediaTypes.defaultItemImage, appStyles);

  return (
    <List.Card
      classNames={classNames}
      appStyles={appStyles}
      onClick={onClick}
      refEl={refEl}
      animateCard={shouldAnimateCard}
      style={{
        position: "relative",
        ...(isFlexRow
          ? { height: orderItemsCardHeight, flexDirection: "row" }
          : { flexDirection: "column", paddingBottom: "10px" }),
        ...style,
      }}
    >
      {loading && (
        <div className={styles.MenuItemLoader}>
          <AppContainer.CenteredColumn
            style={{ height: "100%", justifyContent: "center" }}
          >
            <Loader appStyles={appStyles} />
          </AppContainer.CenteredColumn>
        </div>
      )}
      {isLocked && !userUnlockedDeal && (
        <div
          style={{ color: appStyles.lockIconColor }}
          className={classnames(styles.LockedDisplay, isFlexRow && styles.Row)}
        >
          {isGiftItem && (
            <span style={{ textAlign: "center", fontSize: "0.8rem" }}>
              {title}
            </span>
          )}
          <span
            className={classnames(
              styles.LockClosedIcon,
              userUnlockedDeal && styles.Unlocked,
              isFlexRow && styles.Row,
            )}
          >
            <LockClosedIcon />
          </span>
          {lockDescription && (
            <span
              style={{
                textAlign: "center",
                fontSize: "1rem",
                fontWeight: "bold",
              }}
            >
              {lockDescription}
            </span>
          )}
        </div>
      )}
      {itemToAnimate && (
        <Confetti
          height={itemToAnimate.innerHeight}
          width={itemToAnimate.innerWidth}
          colors={[appStyles.accentColor, appStyles.actionColor, "#fff"]}
          numberOfPieces={600}
          recycle={false}
          initialVelocityX={4}
          initialVelocityY={4}
        />
      )}
      {isLocked && (
        <div
          className={classnames(
            styles.LockedItemOverlay,
            userUnlockedDeal && styles.Unlocked,
          )}
        />
      )}
      {!isImageByUrl && (
        <div
          className={classnames(isFlexRow && styles.RowFlexLayout)}
          style={{
            position: "relative",
            color: appStyles.lockIconColor,
          }}
        >
          {(userUnlockedDeal || isDealUsedInOrder) && (
            <div>
              <div
                className={styles.LockOpenFlag}
                style={
                  isDealUsedInOrder || userUnlockedDeal
                    ? { borderTopColor: appStyles.accentColor }
                    : { borderTopColor: "rgba(0,0,0,0.7)" }
                }
              />
              {userUnlockedDeal ? (
                <LockOpenIcon className={classnames(styles.LockOpenIcon)} />
              ) : (
                <GiftIcon className={classnames(styles.GiftIcon)} />
              )}
            </div>
          )}

          {isDeal && displayDealBadge && (
            <div
              style={{
                position: "absolute",
                left: 0,
                margin: 5,
                top: 0,
                width: "calc(100% - 14px)",
                height: imageHeight - 10,
                border: "2px dashed #777",
                zIndex: 2,
              }}
            />
          )}

          {isDeal && displayDealBadge && _.isNumber(totalDealPrice) && (
            <div
              style={{
                position: "absolute",
                right: "1em",
                top: 0,
                height: 56,
                width: 70,
                zIndex: 3,
                background: appStyles.accentColor,
                ...DealBadge,
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-start",
                  justifyContent: "center",
                  paddingTop: 10,
                }}
              >
                <div style={{ fontSize: 10 }}>$</div>
                <div style={{ fontSize: 36 }}>
                  {totalDealPrice.toString().split(".")[0]}
                </div>
                <div style={{ fontSize: 16 }}>
                  {_.get(totalDealPrice.toString().split("."), "1", "")}
                </div>
              </div>
            </div>
          )}

          {withPoints && (
            <div
              style={{
                position: "absolute",
                right: "1em",
                top: 0,
                height: "auto",
                width: 70,
                zIndex: 3,
                background: appStyles.accentColor,
                ...GiftBadge,
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: 10,
                  marginBottom: 10,
                }}
              >
                <div style={{ fontSize: 30 }}>{giftPrice}</div>
                <div style={{ fontSize: 10 }}>{T("Points")}</div>
              </div>
            </div>
          )}

          {imageKey && !isImageByUrl ? (
            <Image
              imagePreview={imagePreview}
              mediaType={
                isDeal
                  ? mediaTypes.deal
                  : withPoints
                  ? mediaTypes.coupon
                  : useCategoryImage
                  ? mediaTypes.menuCategory
                  : mediaTypes.menuItem
              }
              mediaKey={imageKey}
              sizes={menuItemSizes(isFlexRow)}
              className={classnames(
                isFlexRow ? styles.RowFlexLayout : styles.ColumnFlexLayout,
                isLocked && styles.LockedDealImage,
                userUnlockedDeal && styles.UnlockedDealImage,
              )}
              imgStyle={{
                ...orderItemImageFitStyle,
                ...(withPoints && { objectFit: "cover" }),
              }}
              wrapperStyle={{ height: isFlexRow ? itemHeight : imageHeight }}
            />
          ) : defaultItemImage ? (
            <Image
              imagePreview={defaultItemImage.imagePreview}
              mediaKey={defaultItemImage.imageKey}
              mediaType={mediaTypes.defaultItemImage}
              sizes="400px"
              className={
                isFlexRow ? styles.RowFlexLayout : styles.ColumnFlexLayout
              }
              imgStyle={{
                objectFit: "contain",
                top: "25%",
                left: "25%",
                width: "50%",
                height: "50%",
                backgroundColor:
                  appStyles.defaultImageBackgroundColor || "#eee",
              }}
              wrapperStyle={{
                backgroundColor:
                  appStyles.defaultImageBackgroundColor || "#eee",
                ...(isFlexRow
                  ? { height: itemHeight }
                  : { height: imageHeight }),
              }}
            />
          ) : (
            <List.Card.Image
              classNames={classnames(
                isLocked && styles.LockedDealImage,
                userUnlockedDeal && styles.UnlockedDealImage,
                isFlexRow ? styles.RowFlexLayout : styles.ColumnFlexLayout,
              )}
              height={isFlexRow ? orderItemsCardHeight : 200}
            >
              <PlateIcon />
            </List.Card.Image>
          )}
          <AllergensDecorator
            allergens={allergens}
            appStyles={appStyles}
            wrapperClassNames={classnames(
              !isFlexRow && styles.HideOnMobile,
              styles.HideOnDesktop,
              styles.AllergensDecorator,
              styles.RowLayout,
              appStyles.rtl && styles.RTL,
            )}
          />
        </div>
      )}
      {isImageByUrl && (
        <List.Card.Image height={200} width="100%">
          <ImgFromUrl
            height={200}
            width="100%"
            style={{
              maxWidth: "100%",
              maxHeight: "auto",
              objectFit: "cover",
            }}
            src={image}
          />
        </List.Card.Image>
      )}
      <List.Card.Content tight={isFlexRow}>
        {isNew && (
          <div
            style={{ color: appStyles.actionColor }}
            className={styles.NewGift}
          >
            {T("NEW")}
          </div>
        )}
        <List.Card.Title appStyles={appStyles}>
          <span
            style={{
              justifyContent: "space-between",
              display: "flex",
              flexGrow: 1,
            }}
            className={classnames(isFlexRow && styles.MenuItemTitle)}
          >
            <span>
              <strong style={ListCardTitle}>
                {isMenuItem || isGiftItem || (isDeal && title)
                  ? title
                  : description}
              </strong>
            </span>
            {isMenuItem && !appStyles.hidePricesInOrderView && prices && (
              <span style={{ fontWeight: "bold", ...MenuItemPrice }}>
                <span style={{ paddingRight: currencySymbol !== " " ? 2 : 0 }}>
                  {displayPrices(prices, {
                    currencySymbol,
                    fixedPoint: appStyles.pricesFixedPoint,
                    shouldDisplayMinOnly: appStyles.displayOnlyMinPrice,
                  })}
                </span>
              </span>
            )}
          </span>
        </List.Card.Title>
        {(isGiftItem || (isDeal && title)) && (
          <List.Card.Description style={{ height: "auto" }}>
            <List.Card.Description.ExtraInfo>
              <div>
                <span>
                  {translatedDescription}
                  <br />
                  <br />
                  {expirationDate && (
                    <span>
                      <CalendarIcon />
                      {` ${T("Valid until:")} ` +
                        moment(new Date(expirationDate)).format(
                          appStyles.giftsExpirationDateFormat || "MMM Do YY",
                        )}
                    </span>
                  )}
                </span>
              </div>
            </List.Card.Description.ExtraInfo>
          </List.Card.Description>
        )}
        {isMenuItem && (
          <React.Fragment>
            <List.Card.Description>
              {translatedDescription.length > DESCRIPTION_MAX_LENGTH
                ? translatedDescription.slice(0, DESCRIPTION_MAX_LENGTH) + "..."
                : translatedDescription}
            </List.Card.Description>
            <AllergensDecorator
              allergens={allergens}
              appStyles={appStyles}
              wrapperClassNames={classnames(
                styles.AllergensDecorator,
                itemFlexLayout === "row" && styles.HideOnMobile,
              )}
            />
          </React.Fragment>
        )}
        {_.isFunction(actionsRenderer) && actionsRenderer()}
      </List.Card.Content>
    </List.Card>
  );
};

const displayPrice = (price, { currencySymbol, fixedPoint }) =>
  `${currencySymbol}${fixedPoint ? price.toFixed(fixedPoint) : price}`;

const displayPrices = (
  prices,
  { currencySymbol, fixedPoint, shouldDisplayMinOnly },
) => {
  const priceRange = _.castArray(prices).slice(0, 2);

  if (_.some(priceRange, _.negate(_.isNumber))) {
    return "";
  }
  if (
    priceRange.length === 1 ||
    (priceRange.length === 2 && shouldDisplayMinOnly)
  ) {
    return displayPrice(priceRange[0], { currencySymbol, fixedPoint });
  }
  if (priceRange.length === 2) {
    return `${displayPrice(priceRange[0], {
      currencySymbol,
      fixedPoint,
    })}-${displayPrice(priceRange[1], {
      currencySymbol,
      fixedPoint,
    })} `;
  }
  return "";
};

const menuItemSizes = (isFlexRow) =>
  `(max-width: ${breakpoints.values.sm - 1}px) ${
    isFlexRow ? 300 : 600
  }px, 600px`;

const DESCRIPTION_MAX_LENGTH = 116;
